import { createFileRoute, redirect } from "@tanstack/react-router";

import { isProjectTypeAdmin } from "@/core/lib/access";
import { FAS_PROJECT_TYPE } from "@/core/lib/constants";

export const Route = createFileRoute("/_protected/fas/taxonomies/$taxonomyId")({
  beforeLoad: ({ context }) => {
    if (!isProjectTypeAdmin(context.user, FAS_PROJECT_TYPE)) {
      throw redirect({ to: "/fas/projects" });
    }
  },
});
